import useDyspozycjaForm from '../../common/hooks/useDyspozycjaForm'

export default function useDyspozycjaEdit() {
	return useDyspozycjaForm('edit')
}
